<!--*ngIf='{desktop: (deviceS.isDesktop$|async), mobile: (deviceS.isMobile$|async)} as obj'-->
<div class='wrapperGreet' [class.wrapperGreet--forMobileFlexRow]='forMobileFlexRow'>
  <span>{{null|getGreet}},&nbsp;</span>
  <span>{{meS.me?.preferredName?.trim() || meS.me?.firstName?.trim()}}!</span>
</div>
